<template>
  <div>
    <v-col cols="12">
      <v-data-table :items="gmcData.account_issues" :headers="headers">
        <template v-slot:item.title="{ item }">
          <template v-if="item.prioritization == 'Warning'">
            <v-icon color="orange">mdi-alert</v-icon>
          </template>
          <template v-if="item.prioritization == 'Error'">
            <v-icon color="red">mdi-alert-circle</v-icon>
          </template>
          <template v-if="item.prioritization == 'Notification'">
            <v-icon color="blue">mdi-alert-circle-outline</v-icon>
          </template>
          &nbsp;
          {{ item.title }}
        </template>
      </v-data-table>
    </v-col>
  </div>
</template>

<script>
export default {
  name: "AccIssueData",
  props: {
    gmcData: Object,
  },
  data: () => ({
    headers: [
      { text: "Issue", align: "start", value: "title", sortable: false },
      { text: "Detail", value: "detail", sortable: false },
      { text: "Documentation", value: "documentation", sortable: false },
    ],
  }),
  methods: {},
  mounted() {
    console.log("AccIssueData: ", this.gmcData);
  },
};
</script>

<style lang="scss" scoped>
</style>